<div class="connection">
  <div class="connection__row">
    <div class="connection__header">
      <div class="connection__title">
        <h3>
          {{ "Global.Connection" | translate }} {{ connectionNumber() }}
          @if (endpoints()) {
            <span> {{ fromCity() }} - {{ toCity() }} </span>
          }
        </h3>
      </div>
      <div>
        @if (isSelfServiceAvailable()) {
          <overflow-menu-button [enabled]="selfServiceEnabled()">
            <div
              class="overflow-menu__item"
              (click)="openSelfserviceDialog('vlan-lightpath')"
              [matTooltip]="'Selfservice.Tooltip.Vlan' | translate"
              matTooltipPosition="above"
            >
              {{ "OverflowMenu.ModifyVlan" | translate }}
            </div>
          </overflow-menu-button>
        }
      </div>
    </div>
    <div class="connection__flex">
      @if (fromSap() && toSap()) {
        <sap-tile [sap]="fromSap()" [healthStatus]="fromHealthStatus()"></sap-tile>
        <div class="connection__connector-wrapper">
          <div class="connection__connector-meta">
            <div class="connection__connector-heading">{{ "ServiceElement.Chart.NowIn" | translate }}</div>
            <div>{{ trafficIn() | readable_size }}</div>
          </div>
          <div class="connection__connector">
            <div class="connection__connector-left">
              <span class="connection__connector-left-top"></span>
              <span class="connection__connector-left-bottom"></span>
            </div>
            <div class="connection__connector-center">
              <span class="connection__connector-center-left"></span>
              <span class="connection__connector-center-right"></span>
            </div>
            <div class="connection__connector-right">
              <span class="connection__connector-right-top"></span>
              <span class="connection__connector-right-bottom"></span>
            </div>
          </div>
          <div class="connection__connector-meta">
            <div class="connection__connector-heading">{{ "ServiceElement.Chart.NowOut" | translate }}</div>
            <div>{{ trafficOut() | readable_size }}</div>
          </div>
        </div>
        <sap-tile [sap]="toSap()" [healthStatus]="toHealthStatus()"></sap-tile>
      }
    </div>
  </div>
</div>
